import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  Column,
  DataTable,
  Link,
  Modal,
  Pagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  RadioButton,
  RadioButtonGroup,
  Theme,
  Button,
} from 'carbon-components-react';
import { getAttachmentsRtvOrHoldLog, getHoldPaymentToLog, getRejectInfoToLog, getResoucesForViews } from '../../services/services';
import SessionController from '../../components/FrontSessionController/SessionController';
import CommodityHeader from '../../components/Header';
import MessageModal from '../../components/MessageModal/MessageModal';
import { useNavigate } from "react-router-dom";

const headers = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'compcode',
    header: 'Company',
  },
  {
    key: 'invonumb',
    header: 'Internal Reference',
  },
  {
    key: 'rcpowayb',
    header: 'Invoice',
  },
  {
    key: 'cancelled',
    header: 'Cancelled',
  },
  {
    key: 'user',
    header: 'User',
  },
  {
    key: 'userwhocancelled',
    header: 'User who cancelled',
  },
];

const modalHeaders = [
  {
    key: 'mailsupplier',
    header: 'Mail Supplier',
  },
  {
    key: 'user',
    header: 'User',
  },
  {
    key: 'action',
    header: 'Action',
  },
  {
    key: 'comments',
    header: 'Comments',
  },
  {
    key: 'reasonrtv',
    header: 'Reason RTV',
  },
  {
    key: 'dateofaction',
    header: 'Date Of Action',
  },
  {
    key: 'hourofaction',
    header: 'Hour Of Action',
  },
];

const RTVLog = () => {

  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [invoiceInformationModal, setInvoiceInformationModal] = useState(false);
  const [allRows, setAllRows] = useState([]);
  const [modalInfo, setModalInfo] = useState([]);
  const [modalRows, setModalRows] = useState([]);
  const [rtvList, setRtvList] = useState([]);
  const [holdList, setHoldList] = useState([]);
  const [messageSessionLost, setMessageSessionLost] = useState('');

  const processingRequest = useRef(false);
  const messageResponse = useRef([]);  
  const [messageModal, setMessageModal] = useState('');
  const [typeSearch, setTypeSearch] = useState('RTV');

  const openMessageModal = (response) => {    
    let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }

  const closeMessageModal = () => {
    setMessageModal(false);    
    messageResponse.current = [];
  }

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  }

  const getListRTVandHold = async (request) => {
    document.body.className = 'waiting';
    await getResoucesForViews(request)
    .then(response => {
      if(response.status === 200){
        response.json()
        .then(response => {
          parserResponseListAll(response);
        })
      }  else if(response.status === 410)   {
        response.text()
        .then(res => {
          setMessageSessionLost(res)                             
        })
      }   
    });    
    document.body.className = '';
  }

  const goHomeScreen = () => {
    navigate('/home')
  };

  const isRequestActive = (enable) => {
    if(enable){
      if(processingRequest.current){
        openMessageModal('The request is processing');
        return true;
      }
      document.body.className = 'waiting';
      processingRequest.current = enable;      
      return false;
    }else{
      processingRequest.current = enable;
      document.body.className = '';
    }
    return false;
  }

  const getRejectModalInfo = async (request) => {
    if(isRequestActive(true)){
      return;
    }    
    await getRejectInfoToLog(request)
    .then(response => {
      if(response.status === 200){
        response.json()
        .then(res => {            
          parserResponseModalInfo(res);            
        })
      } else if(response.status === 410)   {
        response.text()
        .then(res => {
          setMessageSessionLost(res)                             
        })
      }  
    });
    isRequestActive(false);
  }
  
  const parserResponseModalInfo = (response) => {
    const parsed = {};
    parsed["idDoc"] = response[0].idDoc === undefined ? response[0].iddoc : response[0].idDoc;
    parsed["ctrycode"] = response[0].ctrycode;
    parsed["compcode"] = response[0].compcode;
    parsed["invonumb"] = response[0].invonumb;
    parsed["docStatus"] = response[0].docStatus;
    parsed["suppliername"] = response[0].suppliername;
    parsed["suppliernumber"] = response[0].suppliernumber;
    parsed["rcpowayb"] = response[0].rcpowayb;
    parsed["attachedQuantity"] = response[0].attachedQuantity;

    setModalInfo(parsed);
    const resParsedRows = response.map((res, i) => {
      if (res.action.toLowerCase().includes("hold")) {
        const parsed = {};
        parsed["id"] = "" + i.toString();
        parsed["mailsupplier"] = res.providerMail;
        parsed["user"] = res.user;
        parsed["action"] = res.action;
        parsed["comments"] = res.justification;
        parsed["reasonrtv"] = res.holdOption;
        parsed["dateofaction"] = res.date;
        parsed["hourofaction"] = res.time;
  
        return parsed;
      } else {
        const parsed = {};
        parsed["id"] = "" + i.toString();
        parsed["mailsupplier"] = res.providerMail;
        parsed["user"] = res.user;
        parsed["action"] = res.action;
        parsed["comments"] = res.comments;
        parsed["reasonrtv"] = res.rtvReason;
        parsed["dateofaction"] = res.date;
        parsed["hourofaction"] = res.time;
  
        return parsed;
      }
      
    });
    setModalRows(resParsedRows);
  }

  const parserResponseListAll = (response) => {
    
    const resParsedRtv = response.lRtvs.map((res, i) => {
      const parsed = {};
      if (res.action === "Return To Vendor") {
        parsed["id"] = i;
        parsed["idDoc"] = res.idDoc;
        parsed["ctrycode"] = res.ctrycode;
        parsed["compcode"] = res.compcode;
        parsed["invonumb"] = res.invonumb;
        parsed["rcpowayb"] = res.rcpowayb;
        parsed["cancelled"] = res.docStatus.trim() === "RTV" ? ("No") : ("Yes");
        parsed["user"] = res.user;
        parsed["userwhocancelled"] = res.docStatus.trim() === "RTV" ? ("Empty") : (res.cancelUser);
      } 
      return parsed;
    });

    const resParsedHold = response.lHolds.map((res, i) => {
      const parsed = {};
      if (res.action === "Hold Payment") {
        parsed["id"] = i;
        parsed["idDoc"] = res.idDoc;
        parsed["ctrycode"] = res.ctrycode;
        parsed["compcode"] = res.compcode;
        parsed["invonumb"] = res.invonumb;
        parsed["rcpowayb"] = res.rcpowayb;
        parsed["cancelled"] = res.docStatus.trim() === "Hold" ? ("No") : ("Yes");
        parsed["user"] = res.user;
        parsed["userwhocancelled"] = res.docStatus.trim() === "Hold" ? ("Empty") : (res.cancelUser);
      }
      return parsed;
    });
    
    setRtvList(resParsedRtv);      
    setHoldList(resParsedHold);
    setAllRows(resParsedRtv); //by default load first RTV    
  }

  function loadTable(type) {
    if (type === "RTV") {
      setAllRows(rtvList);
    } else if (type === "HOLD") {
      setAllRows(holdList);
    }
    setTypeSearch(type);
  };

  const generateLinks = (attachquantity, idDoc) => {
    const linkElements = [];    
    for (let i = 1; i <= attachquantity; i++) {
      linkElements.push(
        <Link key={i} onClick={() => downloadInvoice(idDoc, i)}>
          {"Download-"}{i}
        </Link>
      );
    }
    return linkElements;
  };

  const download = async (request) => {
    if(isRequestActive(true)){
      return;
    }
    await getAttachmentsRtvOrHoldLog(request)
    .then(response => {      
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = response.headers.get('content-disposition');
        a.click();
      });
    });
    isRequestActive(false);
  }
    
  function downloadInvoice(idDoc, index) {
    let request = {};
    request.idDoc = idDoc;
    request.index = index
    download(request)
  };

  const openModal = (rowData) => {        
    let request = {};
    request.idDoc = allRows[rowData.id].idDoc;
    request.typeSearch = typeSearch;
    
    getRejectModalInfo(request)        
    setInvoiceInformationModal(true);
  };
  const closeModal = () => {
    setInvoiceInformationModal(false);
    setModalInfo([]);
    setModalRows([]);
  };

  useEffect(() => {
    const request = {};
    request.viewName = 'logReturnAndHold';
    getListRTVandHold(request);
  }, []);

  return (
    <>
      <h2 className="table-title">Log RTV</h2>
      <Theme theme="g90">
            <CommodityHeader />
        </Theme>
      <Grid>
      
        <Modal
          className="RTVLog-modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="Invoice Information"
          modalAriaLabel="Invoice Information"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeModal}
          onRequestSubmit={closeModal}
          onSecondarySubmit={closeModal}
          open={invoiceInformationModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Close"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={<p><strong>Invoice Information</strong></p>}
        >
          <Grid>
            <Column lg={16}>
              <Table>
                <TableRow>
                  <TableCell> <p className=""><strong>Country: </strong></p></TableCell>
                  <TableCell> <p className> {modalInfo.ctrycode} </p></TableCell>
                  <TableCell> <p className=""><strong>Company: </strong></p></TableCell>
                  <TableCell> <p className> {modalInfo.compcode} </p></TableCell>
                  <TableCell> <p className=""><strong>Internal Reference: </strong></p></TableCell>
                  <TableCell> <p className> {modalInfo.invonumb} </p></TableCell>
                  <TableCell> <p className=""><strong>Actual State: </strong></p></TableCell>
                  <TableCell> <p className> {modalInfo.docStatus} </p></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell> <p className=""><strong>Supplier's Name: </strong></p></TableCell>
                  <TableCell> <p className> {modalInfo.suppliername} </p></TableCell>
                  <TableCell> <p className=""><strong>Supplier's Number: </strong></p></TableCell>
                  <TableCell> <p className> {modalInfo.suppliernumber} </p></TableCell>
                  <TableCell> <p className=""><strong>Invoice Number: </strong></p></TableCell>
                  <TableCell> <p className> {modalInfo.rcpowayb} </p></TableCell>
                  <TableCell> <p className=""><strong>Link To Adjunts: </strong></p></TableCell>
                  <TableCell>
                    <Column className="style-column-links-download">
                      {generateLinks(modalInfo.attachedQuantity, modalInfo.idDoc)}
                    </Column>
                  </TableCell>
                </TableRow>
              </Table>
            </Column>
          </Grid>
          <Column className="column-table-RTV-log">
            <DataTable
              isSortable="true"
              rows={modalRows}
              headers={modalHeaders}
              render={({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getTableProps
              }) => (
                <TableContainer>
                  <Table {...getTableProps()} useZebraStyles>
                    <TableHead>
                      <TableRow>
                        {headers.map(header => (
                          <TableHeader {...getHeaderProps({ header })}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row) => (
                        <TableRow {...getRowProps({ row })}>
                          {row.cells.map(cell => (
                            <>
                              {cell.id.includes("comments") || cell.id.includes("reason") ? (
                                <TableCell className='style-size-column-modal-rtvlog' key={cell.id}>{cell.value === "" ? ("Empty") : (cell.value)}</TableCell>

                              ) : (
                                <TableCell className='style-size-column-modal-rtvlog2' key={cell.id}>{cell.value === "" ? ("Empty") : (cell.value)}</TableCell>

                              )}

                            </>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            />
          </Column>
        </Modal >
      </Grid >
      <Grid>
        <Column lg={16}>
          <Button className='style-bttbackID' size="lg" style={{marginBottom: '20px'}} 
            onClick={goHomeScreen}>Back to Home</Button>          
          <DataTable
            isSortable="true"
            rows={allRows}
            headers={headers}
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps,
              onInputChange
            }) => (

              <TableContainer>
                <RadioButtonGroup legendText={<p><strong>Select</strong></p>} name="select-radio-button"
                    valueSelected={typeSearch}>                   
                  <RadioButton labelText="Return to Vendor" onClick={() => loadTable("RTV")} 
                    checked={typeSearch === 'RTV'}
                    value="RTV" id="rtv" />
                  <RadioButton labelText="Hold Payments" onClick={() => loadTable("HOLD")} 
                    checked={typeSearch === 'HOLD'}
                    value="HOLD"  id="hold" />
                </RadioButtonGroup>
                {/* <p className="table-content-title"><strong>Click on a row to see more information.</strong></p> */}
                <h5 className='style-moreinfo'>Click on a row to see detailed information</h5>
                <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
                    {/* pass in `onInputChange` change here to make filtering work */}
                  </TableToolbarContent>
                </TableToolbar>
                <Table {...getTableProps()} useZebraStyles>
                  <TableHead>
                    <TableRow>
                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row, i) => (
                      <TableRow onClick={() => openModal(row)} {...getRowProps({ row })}>
                        {row.cells.map(cell => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Pagination
                  onChange={changePaginationState}
                  backwardText="Previous page"
                  forwardText="Next page"
                  itemsPerPageText="Items per page:"
                  page={page}
                  pageNumberText="Page Number"
                  pageSize={pageSize}
                  pageSizes={[
                    10,
                    25,
                    50,
                    100,
                  ]}
                  totalItems={rows.length}
                />
              </TableContainer>
            )}
          />
        </Column>        
      </Grid>
      <SessionController messageLostSessionCallback={messageSessionLost} />
      <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>
    </>
  );
};

export default RTVLog;